import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchClientHistoryReport } from "../../../../store/thunks/reportsThunk";
import Table from "../../../../applicationUi/components/Table";
import * as XLSX from "xlsx";
import ClientModal from "../../../../modals/ClientModal";
import { fetchClientById } from "../../../../store/thunks/clientsThunk";
// import { FunnelChart, Funnel, Tooltip, LabelList } from "recharts";
// import ClientBookingManager from "../../../../applicationUi/components/ClientBookingManager";

const ClientHistoryReport = () => {
  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);
  const [funnelData, setFunnelData] = useState([]);
  const [isClientModalOpen, setIsClientModalOpen] = useState(false);
  const itemsPerPage = 10;
  const clientHistory = useSelector(
    (state) =>
      state?.reports?.clientHistory || { data: [], loading: false, error: null }
  );
  const report = clientHistory.data || [];
  const loading = clientHistory.loading || false;
  const error = clientHistory.error || null;

  useEffect(() => {
    dispatch(fetchClientHistoryReport());
  }, [dispatch]);

  useEffect(() => {
    if (report && report.length > 0) {
      const intakeCount = report.filter(
        (client) => client.dateOfIntake !== "N/A"
      ).length;
      const assessmentCount = report.filter(
        (client) => client.dateOfAssessment !== "N/A"
      ).length;
      const treatmentCount = report.filter(
        (client) => client.dateOfFirstTreatment !== "N/A"
      ).length;
      const totalTreatments = report.reduce(
        (sum, client) => sum + (client.totalAppointments || 0),
        0
      );

      setFunnelData([
        { name: "Intake Booked", value: intakeCount },
        { name: "Assessment Booked", value: assessmentCount },
        { name: "Treatment Booked", value: treatmentCount },
        { name: "Total Treatments", value: totalTreatments },
      ]);
    }
  }, [report]);

  const columns = [
    { header: "Client Name", accessor: "clientName" },
    { header: "Email", accessor: "email" },
    { header: "Additional Emails", accessor: "additionalEmails" },
    { header: "Date Added", accessor: "dateAdded" },
    { header: "Date of Intake", accessor: "dateOfIntake" },
    { header: "Date of Assessment", accessor: "dateOfAssessment" },
    { header: "Date of First Treatment", accessor: "dateOfFirstTreatment" },
    { header: "Total Appts", accessor: "totalAppointments" },
  ];

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowClick = (clientId) => {
    dispatch(fetchClientById(clientId));
    setIsClientModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsClientModalOpen(false);
  };

  const handleDownloadExcel = () => {
    const worksheet = XLSX.utils.json_to_sheet(report);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "ClientHistory");
    const workbookOutput = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });
    const blob = new Blob([workbookOutput], {
      type: "application/octet-stream",
    });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "ClientHistoryReport.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  if (loading) return <div>Loading...</div>;
  if (error)
    return (
      <div className="text-red-500">
        {typeof error === "object" ? JSON.stringify(error) : error}
      </div>
    );
  if (!report || report.length === 0)
    return <div>No client history found.</div>;

  const totalItems = Array.isArray(report) ? report.length : 0;
  const totalPages = Math.ceil(totalItems / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedData = report.slice(startIndex, startIndex + itemsPerPage);

  return (
    <div className="space-y-8">
      <div className="bg-white shadow-sm rounded-sm">
        <Table
          columns={columns}
          data={paginatedData}
          title="Client History Report"
          description="Displays the date a client was added, date of intake, assessment, and first treatment."
          showPagination={true}
          currentPage={currentPage}
          totalPages={totalPages}
          totalResults={totalItems}
          onPageChange={handlePageChange}
          onRowClick={handleRowClick}
          actions={[
            {
              label: "Download as Excel",
              onClick: handleDownloadExcel,
            },
          ]}
          highlightField="isParent"
        />
      </div>

      {/* Client Modal */}
      <ClientModal
        isOpen={isClientModalOpen}
        onClose={handleCloseModal}
      />

      {/* <ClientBookingManager /> */}
    </div>
  );
};

export default ClientHistoryReport;
